import { getCompanies } from "common/functions/api/companies";
import { handleError } from "common/functions/utilities";
import { useEffect } from "react";
import useSWR from "swr";

export const useCompanyWithSearchStringHooks = (
  searchString: string | null | undefined,
  setFatal: ((error?: string | null | undefined) => void) | undefined
) => {
  const { data, error, isLoading } = useSWR(
    `companies of ${searchString}`,
    () => {
      if (searchString) {
        return getCompanies({ name: searchString });
      }
      return [];
    }
  );

  useEffect(() => {
    if (error) {
      handleError(error, setFatal, "選択肢を読み込めませんでした。");
    }
  }, [error, setFatal]);

  return { companies: data ?? [], busy: isLoading } as const;
};
